export const EVoucherIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M20.334 3.60034C21.1071 3.60034 21.7342 4.22671 21.7344 4.99976V16.9998C21.7344 17.773 21.1072 18.4001 20.334 18.4001H1.66699C0.893944 18.4 0.267578 17.7728 0.267578 16.9998V13.1326C0.267608 12.9485 0.416539 12.7996 0.600586 12.7996H1.04492C2.13924 12.7986 3.01556 11.9876 3.0166 10.9998C3.0153 10.0121 2.13895 9.20191 1.04492 9.20093H0.600586C0.416647 9.20089 0.267783 9.05182 0.267578 8.86792V4.99976C0.267755 4.22682 0.894052 3.60052 1.66699 3.60034H20.334ZM2.02246 5.03491C1.91223 5.03514 1.82329 5.12483 1.82324 5.23511V7.68042C1.82329 7.77491 1.89037 7.85861 1.98633 7.88354C3.48226 8.27112 4.57039 9.51586 4.57227 10.9998C4.57036 12.5443 3.39191 13.8291 1.82324 14.155V16.7654C1.82344 16.8755 1.91232 16.9644 2.02246 16.9646H19.9785C20.0888 16.9645 20.1785 16.8756 20.1787 16.7654V5.23511C20.1787 5.12472 20.0889 5.03496 19.9785 5.03491H2.02246ZM1.7793 14.0974L1.79004 14.1628L1.79102 14.1609L1.7793 14.0974Z"
        fill="#011BB6"
        stroke="#011BB6"
        strokeWidth="0.133333"
      />
      <path
        d="M14.2932 7.91239L13.3927 9.73826L11.3779 10.032C11.0166 10.0844 10.8718 10.5298 11.1338 10.785L12.5914 12.2054L12.2467 14.2119C12.1846 14.5746 12.5666 14.8463 12.8866 14.6766L14.689 13.7292L16.4914 14.6766C16.8113 14.8449 17.1933 14.5746 17.1313 14.2119L16.7865 12.2054L18.2442 10.785C18.5062 10.5298 18.3614 10.0844 18.0001 10.032L15.9853 9.73826L15.0848 7.91239C14.9234 7.58694 14.4559 7.5828 14.2932 7.91239Z"
        fill="#011BB6"
      />
      <rect x="7" y="7" width="1.33333" height="2.66667" fill="#011BB6" />
      <rect x="7" y="12.3334" width="1.33333" height="2.66667" fill="#011BB6" />
    </svg>
  );
};
